module.exports = __webpack_public_path__ + "static/media/histiocytoma40x.b4fe2d84.JPG";